import React, { useState, useEffect } from 'react';
import { AlertTriangle, Loader2, Plus } from 'lucide-react';
import { supabase } from '../../lib/supabase';
import DataTable from '../../components/admin/DataTable';
import FormModal from '../../components/admin/FormModal';

const columns = [
  { key: 'name', label: 'Şehir Adı' },
  { key: 'plate_number', label: 'Plaka Kodu' }
];

const formFields = [
  { name: 'name', label: 'Şehir Adı', type: 'text' },
  { name: 'plate_number', label: 'Plaka Kodu', type: 'number' }
];

export default function AdminCities() {
  const [cities, setCities] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingCity, setEditingCity] = useState<any>(null);
  const [formValues, setFormValues] = useState<any>({});

  useEffect(() => {
    loadCities();
  }, []);

  const loadCities = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('cities')
        .select('*')
        .order('name');
      
      if (error) throw error;
      setCities(data || []);
    } catch (err) {
      console.error('Error loading cities:', err);
      setError('Şehirler yüklenirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (city: any) => {
    setEditingCity(city);
    setFormValues(city);
    setIsModalOpen(true);
  };

  const handleDelete = async (city: any) => {
    if (!window.confirm('Bu şehri silmek istediğinize emin misiniz?')) return;

    try {
      setLoading(true);
      const { error } = await supabase
        .from('cities')
        .delete()
        .eq('id', city.id);

      if (error) throw error;
      await loadCities();
    } catch (err) {
      console.error('Error deleting city:', err);
      setError('Şehir silinirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setEditingCity(null);
    setFormValues({});
    setIsModalOpen(true);
  };

  const handleSubmit = async (values: any) => {
    try {
      setLoading(true);
      setError(null);

      if (editingCity) {
        const { error } = await supabase
          .from('cities')
          .update({
            name: values.name,
            plate_number: parseInt(values.plate_number)
          })
          .eq('id', editingCity.id);

        if (error) throw error;
      } else {
        const { error } = await supabase
          .from('cities')
          .insert({
            name: values.name,
            plate_number: parseInt(values.plate_number)
          });

        if (error) throw error;
      }

      await loadCities();
      setIsModalOpen(false);
    } catch (err) {
      console.error('Error saving city:', err);
      setError('Şehir kaydedilirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  if (loading && cities.length === 0) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="w-8 h-8 text-yellow-400 animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-white">Şehirler</h1>
      </div>

      {error && (
        <div className="bg-red-500/10 border border-red-500/20 rounded-lg px-4 py-3 flex items-center gap-2">
          <AlertTriangle className="w-5 h-5 text-red-500" />
          <p className="text-red-500">{error}</p>
        </div>
      )}

      <DataTable
        columns={columns}
        data={cities}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onAdd={handleAdd}
      />

      <FormModal
        title={editingCity ? 'Şehir Düzenle' : 'Yeni Şehir Ekle'}
        fields={formFields}
        values={formValues}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleSubmit}
        onChange={(name, value) => setFormValues({ ...formValues, [name]: value })}
      />
    </div>
  );
}